module.exports = __webpack_public_path__ + "img/doggo3.4faa8b69.jpg";